import Settings from 'components/settings'
import { appliesMeta } from '@/utils/functions/applies-meta'

export default appliesMeta({
  requiresAuth: true,
  template: 'chameleon'
},
[
  {
      path: '/settings',
      component: Settings.Index,
      name: 'settings.index',
  },
  {
    path: '/settings/xero',
    component: Settings.Xero,
    name: 'settings.xero',
  },
  {
    path: '/settings/phpinfo',
    component: Settings.PHPStatus,
    name: 'settings.phpinfo',
  },
  {
      path: '/settings/sign-request-templates',
      component: Settings.SignRequestTemplates,
      name: 'settings.sign-request-templates'
  },
  {
      path: '/settings/sign-request-templates/:template_id',
      component: Settings.SignRequestTemplate,
      name: 'settings.sign-request-templates.show'
  },
  {
      path: '/settings/project-agreements',
      component: Settings.ProjectAgreements,
      name: 'settings.project-agreements'
  },
  {
      path: '/settings/project-agreement/:project_agreement_id',
      component: Settings.ProjectAgreement,
      name: 'settings.project-agreements.show'
  },
  {
    path: '/settings/stage-lead-times',
    component: Settings.StageLeadTimes,
    name: 'settings.stage-lead-times'
},
  {
    path: '/settings/ai-history',
    component: Settings.AIHistory,
    name: 'settings.ai-history'
},
  {
    path: '/settings/ai-history/:conversation_id',
    component: Settings.AIHistoryConversation,
    name: 'settings.ai-history.show'
}
])
